
import { Login } from '@/containers/auth/login/Login'
import { useAuth } from '@/context/AuthContext'
import { usePartner } from '@/context/PartnerContext'
import { AuthPageLayout } from 'BrokerTsLib/src/components'
import { useCebiaLogin, useReturnUrlNavigate } from 'BrokerTsLib/src/hooks'
import { useEffect } from 'react'
import { useSearchParams } from 'react-router'

export const LoginPage = () => {
  const [searchParams] = useSearchParams()
  const returnUrl = searchParams.get('returnUrl') ?? undefined
  const error = searchParams.has('error')

  const returnUrlNavigate = useReturnUrlNavigate()
  const { user, isLoggingOut, isLoading } = useAuth()
  useEffect(() => {
    if (user?.logged && !isLoading && !isLoggingOut) {
      returnUrlNavigate(returnUrl ?? '/')
    }
  }, [user, isLoading, isLoggingOut, returnUrl, returnUrlNavigate])

  const { currentPartner } = usePartner()

  useCebiaLogin(searchParams.has('cebia'), returnUrl)

  return (
    <AuthPageLayout title='Vítejte.' subtitle={<>Pokračujte přihlášením<br /> do aplikace.</>} logo={currentPartner?.logo}>
      <Login returnUrl={returnUrl} error={error} />
    </AuthPageLayout>
  )
}